import { computed, type InjectionKey } from "vue";
import type { OrderDto, ProductVariantDto } from "./gfo_api/order_api";
import type { CurrentOrderProvider } from "./current_order_provider";

export interface OptionsNavigationPath {
  path: string;
  title: string;
}
export function OptionsProvider(currentOrderProvider: ReturnType<typeof CurrentOrderProvider>) {
  const optionPathes = computed(() => {
    const currentOrder: OrderDto|null = currentOrderProvider?.currentOrder.value;
    const variants: ProductVariantDto[] = currentOrderProvider?.availableVariants.value;
    let pathes: OptionsNavigationPath[] = [];
    if (!currentOrder) {
      return pathes;
    }
    if (
      0 <
        variants?.filter((v) => -1 < [100, 2, 102].indexOf(v.product_id))
          .length ||
      0
    ) {
      pathes.push({
        path: "/options/access",
        title: "OptionsNavigation_Access",
      });
    }
    if (
      0 <
        variants?.filter((v) => -1 < [103, 24].indexOf(v.product_id)).length ||
      0
    ) {
      pathes.push({
        path: "/options/phone",
        title: "OptionsNavigation_Phone",
      });
    }
    if (
      0 <
        variants?.filter((v) => -1 < [9, 10].indexOf(v.product_id)).length ||
      0
    ) {
      pathes.push({
        path: "/options/tv",
        title: "OptionsNavigation_Tv",
      });
    }
    return pathes;
  });

  return { optionPathes };
}

// gibt bei der injection automatisch den richtigen Typ
export const optionsProviderKey: InjectionKey<
  ReturnType<typeof OptionsProvider>
> = Symbol("options-provider");
